import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { TbMenu } from "react-icons/tb";
import logo from '../images/kaizek-logo.svg';
import Footer from './Footer';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {

    const [onTap, setOnTap] = useState(false);
            
    const [nav, setNav] = useState(false)
    const handleNav = () => {
        setNav(!nav)
        setOnTap((prev) => !prev); 
    }

    const handleScroll = (event, sectionId) => {
        event.preventDefault(); // Prevent default anchor behavior
    
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        };

    return (
        <div className='min-h-screen sm:mt-20 lg:mt-12 xl:mt-8 2xl:mt-12'>
            <Helmet>
                <title>Privacy Policy | Kaizek</title>
                <meta name="Kaizek" content="Specializing in custom firmware, embedded software development, and IoT solutions." />
            </Helmet>

            <nav className='flex-wrap sm:fixed w-full top-0 left-0 z-50 mx-auto lg:my-2'>
                <div className='px-6 lg:mx-14 lg:px-8 2xl:px-12 py-8 lg:py-4 2xl:py-6 lg:rounded-3xl flex items-center justify-between bg-white/60 backdrop-blur-3xl'>
                    <div className='float-start'>
                    <Link to={"/"}><img src={logo} alt="Kaizek-logo"/></Link>
                    </div>
                    
                    <div className='hidden lg:flex justify-center'>
                        <ul className='hidden sm:inline-flex text-xl leading-8'>
                        {/* <Link to='/core-services'> */}
                        <Link to={"/"}><li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'>Services</li></Link>
                        <Link to={"/"}><li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'>Capabilities</li></Link>
                        <Link to={"/"}><li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'>Smart City</li></Link>
                        <Link to={"/"}><li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'>Case Studies</li></Link>
                        <li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'><a href="#contact" onClick={(e) => handleScroll(e, "contact")}>Contact</a></li>            
                        </ul>
                    </div>
                    <div className='hidden xl:flex'>
            
                        <button className="button-theme">
                        Start a project
                        </button>
                    
                    </div>

                    <div onClick={handleNav} className='lg:hidden z-20'>
                    <TbMenu size={20} color={onTap ? '#342E6D' : '#342E6D'} />
                    </div>
                    <div
                    onClick={handleNav}
                    className={nav ? 'overflow-y-hidden z-10 lg:hidden ease-in duration-300 absolute text-[var(--kaizenblue)] left-0 top-0 w-full h-screen bg-[#F7F7F7] px-4 py-8 flex flex-col' : 'absolute top-0 h-screen left-[-100%] ease-in duration-500'}>

                    <div className='place-content-center flex'>
                    <img src={logo} alt="Kaizek logo"/>
                    </div>

                    <ul className='h-max w-full text-center py-8'>
                        <Link to={"/"}><li className='font-symbol px-4 text-2xl py-4'>Services</li></Link>
                        <Link to={"/"}><li className='font-symbol px-4 text-2xl py-4'>Capabilities</li></Link>
                        <Link to={"/"}><li className='font-symbol px-4 text-2xl py-4'>Smart City</li></Link>
                        <Link to={"/"}><li className='font-symbol px-4 text-2xl py-4'>Case Studies</li></Link>
                        <li className='font-symbol px-4 text-2xl py-4'><a href="#contact" onClick={(e) => handleScroll(e, "contact")}>Contact</a></li>
                    </ul>
                    <div className='place-content-center grid grid-flow-row gap-2 place-items-center my-2'>
                        
                            <button className="button-theme">
                            Start a project
                            </button>
                        
                    </div>
                    </div>
                </div>
            </nav>

            <div>
                <div className='flex flex-col items-center mx-4 sm:mx-auto py-12 lg:py-16 xl:py-28 rounded-xl lg:rounded-3xl bg-white '>
                    <h1 className='text-[var(--kaizekblue)] font-uiBold text-4xl xl:text-5xl text-center'>Privacy Policy</h1>
                    
                    <div className='my-8'>
                        <section className='my-8 text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>1. Information We Collect</h2>

                            <h3 className='my-2'>1.1 Information You Provide Through Forms</h3>
                            <p>We collect the following information when you submit inquiries through our website:</p>
                            <ul>
                                <li>Full Name</li>
                                <li>Business Email Address</li>
                                <li>Phone Number</li>
                                <li>Company Name</li>
                                <li>Service of Interest</li>
                                <li>Project Description</li>
                                <li>Estimated Budget</li>
                                <li>Project Timeframe/Deadline</li>
                            </ul>

                            <h3 className=' my-2'>1.2 Automatically Collected Information</h3>
                            <p>We automatically collect:</p>
                            <ul>
                                <li>IP address</li>
                                <li>Browser type and version</li>
                                <li>Device information</li>
                                <li>Pages visited on our website</li>
                                <li>Time and date of visits</li>
                                <li>Referring website addresses</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>2. How We Use Your Information</h2>

                            <h3 className=' my-2'>2.1 Business Communications</h3>
                            <p>We use your contact information to:</p>
                            <ul>
                                <li>Respond to your inquiries</li>
                                <li>Provide information about requested services</li>
                                <li>Send project-related communications</li>
                                <li>Share relevant business updates</li>
                            </ul>

                            <h3 className=' my-2'>2.2 Project Assessment</h3>
                            <p>We use project-related information to:</p>
                            <ul>
                                <li>Evaluate project requirements</li>
                                <li>Prepare customized solutions</li>
                                <li>Estimate timelines and resources</li>
                                <li>Create project proposals</li>
                            </ul>

                            <h3 className='my-2'>2.3 Business Development</h3>
                            <p>We use collected information to:</p>
                            <ul>
                                <li>Improve our services</li>
                                <li>Customize solutions for different industries</li>
                                <li>Analyze service preferences</li>
                                <li>Enhance user experience</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>3. Information Sharing</h2>
                            <p>We may share your information with:</p>
                            <ul>
                                <li>Team members involved in project delivery</li>
                                <li>Technology partners (when necessary for service delivery)</li>
                                <li>Legal authorities (when required by law)</li>
                                <li>Professional service providers</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>4. Data Protection and Security</h2>
                            <p>We implement security measures including:</p>
                            <ul>
                                <li>Secure SSL encryption for form submissions</li>
                                <li>Access controls for client information</li>
                                <li>Regular security audits</li>
                                <li>Employee data handling training</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>5. Your Rights</h2>
                            <p>You have the right to:</p>
                            <ul>
                                <li>Access your personal information</li>
                                <li>Correct inaccurate information</li>
                                <li>Request deletion of your information</li>
                                <li>Opt-out of marketing communications</li>
                                <li>Request data portability</li>
                                <li>Lodge complaints with supervisory authorities</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>6. Cookies and Tracking</h2>
                            <p>We use cookies to:</p>
                            <ul>
                                <li>Improve website functionality</li>
                                <li>Analyze user behavior</li>
                                <li>Remember your preferences</li>
                                <li>Enhance security</li>
                                <li>Provide better user experience</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>7. International Data Transfers</h2>
                            <p>With offices in Ahmedabad, Mumbai, USA, and Spain, <br/> we may transfer your data internationally. We ensure appropriate safeguards through:</p>
                            <ul>
                                <li>Standard contractual clauses</li>
                                <li>Data processing agreements</li>
                                <li>Privacy Shield compliance (where applicable)</li>
                            </ul>
                        </section>

                        <section  className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>8. Contact Us</h2>
                            <p>For privacy-related inquiries:</p>
                            <p>Email: info@kaizek.com</p>
                            {/* <p>Phone: +1 (555) 123-4567 (USA)</p> */}
                        </section>
                </div>
                </div>
            </div>

            <section id='contact'>
                <Footer/>
            </section>
        </div>
    )
}

export default PrivacyPolicy